import { createVanIconComponent } from "./van"

const Down = createVanIconComponent("down")
export default Down
